export default "__VITE_ASSET__QrWzp0Q$__"